// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { zh, en } from "./locales"

// 配置语言资源
const resources = {
  en: {
    translation: en
  },
  zh: {
    translation: zh
  }
  // 你可以继续添加更多语言
};

i18n
  .use(initReactI18next) // 将 i18next 与 react-i18next 集成
  .init({
    resources, // 语言资源
    lng: 'zh',  // 默认语言zh中文，en英文
    interpolation: {
      escapeValue: false, // React 已经做了防止 XSS 攻击
    },
  });

export default i18n;
